var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.49 59.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#66519d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DMS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.58,33.78a.91.91,0,0,0,.46-1c-.06-1.08-.13-2.16-.22-3.24.09,1.08.16,2.16.22,3.24A.91.91,0,0,1,1.58,33.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.23,29.31A3,3,0,0,1,.68,29,3,3,0,0,0,.23,29.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.27,28.83a.72.72,0,0,1,.27.15A.72.72,0,0,0,1.27,28.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.57,33.66A1.09,1.09,0,0,1,.27,33L0,30.43.27,33A1.09,1.09,0,0,0,.57,33.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.57,33.66a.84.84,0,0,0,.66.21.79.79,0,0,0,.35-.09.91.91,0,0,0,.46-1c-.06-1.08-.13-2.16-.22-3.24a.85.85,0,0,0-.28-.6.72.72,0,0,0-.27-.15.79.79,0,0,0-.34,0A.8.8,0,0,0,.68,29a3,3,0,0,0-.45.36L0,29.5v.93L.27,33A1.09,1.09,0,0,0,.57,33.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.51,47.77a6.74,6.74,0,0,1,1.38-1.65A6.74,6.74,0,0,0,1.51,47.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.82,53.91a.8.8,0,0,1-.32,0h0A.8.8,0,0,0,13.82,53.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.43,39.18a5.09,5.09,0,0,0-2.23.4,5.09,5.09,0,0,1,2.23-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.89,49.16a.84.84,0,0,1,.26-.53A.84.84,0,0,0,13.89,49.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.4,40.86a4.84,4.84,0,0,1,.83-.74A4.84,4.84,0,0,0,4.4,40.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.92,54a.78.78,0,0,1-.57-.18.78.78,0,0,0,.57.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.23,53.55a1.06,1.06,0,0,1,0-.33c0-.47,0-.95,0-1.42,0,.47,0,1,0,1.42A1.06,1.06,0,0,0,2.23,53.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.42,49.11a.74.74,0,0,0-.66-.65,1,1,0,0,0-.34,0,.68.68,0,0,0-.27.13.84.84,0,0,0-.26.53,2.16,2.16,0,0,0,0,.36c.13,1.25.22,2.49.31,3.74a.76.76,0,0,1,0,.31.45.45,0,0,1-.35.34.8.8,0,0,1-.32,0H2.92a.78.78,0,0,1-.57-.18.46.46,0,0,1-.12-.23,1.06,1.06,0,0,1,0-.33c0-.47,0-.95,0-1.42,0-.24,0-.47,0-.71s0-.47.06-.71a5.23,5.23,0,0,1,.2-.89A4.79,4.79,0,0,1,4,47.28c.09,0,.13,0,.16.07l.32.33a4.86,4.86,0,0,0,4.72,1.47,5,5,0,0,0,4-4.91,6.06,6.06,0,0,0-.09-1,4.45,4.45,0,0,0-.23-.79,5.11,5.11,0,0,0-1.44-2,5,5,0,0,0-3-1.24,5.14,5.14,0,0,0-3.2.94,4.84,4.84,0,0,0-.83.74,5,5,0,0,0-1.19,4.37.83.83,0,0,1-.32.89,6.74,6.74,0,0,0-1.38,1.65,6,6,0,0,0-.45,1A5.2,5.2,0,0,0,.8,49.78a24.86,24.86,0,0,0-.15,4,1.6,1.6,0,0,0,.35.94,2,2,0,0,0,.51.45,1.87,1.87,0,0,0,1,.28c3.8,0,7.59,0,11.39,0a1.82,1.82,0,0,0,1-.33,1.89,1.89,0,0,0,.67-.83,2.28,2.28,0,0,0,.16-.74c0-.31,0-.62,0-.93s0-.62,0-.93A23.35,23.35,0,0,0,15.42,49.11ZM8.15,40.76a3.44,3.44,0,0,1,3.41,3.45,3.42,3.42,0,1,1-6.84,0A3.45,3.45,0,0,1,8.15,40.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.85,39.72c-.35-1.06-.68-2.13-1-3.21a.9.9,0,0,1,0-.4.9.9,0,0,0,0,.4C1.17,37.59,1.5,38.66,1.85,39.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.72,35.45a.8.8,0,0,1,.67.26.8.8,0,0,0-.67-.26.86.86,0,0,0-.85.66A.86.86,0,0,1,1.72,35.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3,40.35a.87.87,0,0,1-.35,0,.87.87,0,0,0,.35,0,.93.93,0,0,0,.55-1.19A.93.93,0,0,1,3,40.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.85,39.72a1,1,0,0,0,.46.59.9.9,0,0,0,.32.09.87.87,0,0,0,.35,0,.93.93,0,0,0,.55-1.19c-.3-1-.6-2-.92-3a1.14,1.14,0,0,0-.22-.41.8.8,0,0,0-.67-.26.86.86,0,0,0-.85.66.9.9,0,0,0,0,.4C1.17,37.59,1.5,38.66,1.85,39.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22,57.94a.83.83,0,0,0,.34-.5A.83.83,0,0,1,22,57.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.29,58.08a1.29,1.29,0,0,0,.74-.14,1.29,1.29,0,0,1-.74.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.88,56.44c-1.07-.43-2.16-.83-3.26-1.18a.83.83,0,0,0-.34,0,.79.79,0,0,0-.73.59.91.91,0,0,0-.07.35.82.82,0,0,0,.55.74c.71.31,1.43.58,2.16.84.31.11.63.21.88.28l.22.07a1.29,1.29,0,0,0,.74-.14.83.83,0,0,0,.34-.5.9.9,0,0,0,0-.61A.83.83,0,0,0,21.88,56.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,2.67a.8.8,0,0,0-.32-.29A.8.8,0,0,1,19,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.58,4.23a.81.81,0,0,0-.13.62A.81.81,0,0,1,14.58,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.25,2.32a.67.67,0,0,1,.4.06A.67.67,0,0,0,18.25,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.07,3.56a2.46,2.46,0,0,1-.27.33A2.46,2.46,0,0,0,19.07,3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.45,4.85a1,1,0,0,0,.13.32.88.88,0,0,0,.22.25.85.85,0,0,0,.6.17,1,1,0,0,0,.33-.09l1.46-.72c.48-.24,1-.49,1.43-.76a.59.59,0,0,0,.18-.13,2.46,2.46,0,0,0,.27-.33l.1-.13a1.34,1.34,0,0,0-.2-.76.8.8,0,0,0-.32-.29.67.67,0,0,0-.4-.06L18,2.38c-1.09.49-2.16,1-3.2,1.62a.73.73,0,0,0-.26.23A.81.81,0,0,0,14.45,4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.14,1.25c.58-.17,1.17-.32,1.77-.48C22.31.93,21.72,1.08,21.14,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.82.29h0l.39.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.78,2.64a1.3,1.3,0,0,1-.14-.29A1.48,1.48,0,0,1,20.59,2a1.48,1.48,0,0,0,.05.35A1.3,1.3,0,0,0,20.78,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.78,2.64a.75.75,0,0,0,.49.3.87.87,0,0,0,.32,0c1.15-.25,2.3-.52,3.43-.83a.81.81,0,0,0,.5-.39.71.71,0,0,0,0-.62,1.24,1.24,0,0,0-.33-.43L24.82.29l-1,.25-.93.23c-.6.16-1.19.31-1.77.48a.74.74,0,0,0-.55.75,1.48,1.48,0,0,0,.05.35A1.3,1.3,0,0,0,20.78,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.11,27.23a.78.78,0,0,0,.6-.24.78.78,0,0,1-.6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.6,23.25a1,1,0,0,0-.11-.67.93.93,0,0,0-.54-.4.85.85,0,0,0-1.07.63C.64,23.91.44,25,.23,26.15a1,1,0,0,0,.88,1.08.78.78,0,0,0,.6-.24,1.2,1.2,0,0,0,.34-.67C2.23,25.3,2.42,24.28,2.6,23.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.06,18.33a.71.71,0,0,1-.52.17c-3.56,0-7.13,0-10.69,0,3.56,0,7.13,0,10.69,0A.71.71,0,0,0,14.06,18.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,13.46a1.41,1.41,0,0,0-.06.63A1.41,1.41,0,0,1,14,13.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.88,13.81a5.17,5.17,0,0,0,2-.29,5.17,5.17,0,0,1-2,.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.44,4.28a5.09,5.09,0,0,0-2-.53,3.88,3.88,0,0,0-.59,0,3.88,3.88,0,0,1,.59,0A5.09,5.09,0,0,1,10.44,4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,10a5.68,5.68,0,0,0,.15-1,6.44,6.44,0,0,0,0-1,6.44,6.44,0,0,1,0,1A5.68,5.68,0,0,1,13,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.2,17.82a1.23,1.23,0,0,0,0,.29,1.23,1.23,0,0,1,0-.29c0-.68,0-1.36,0-2C2.17,16.46,2.19,17.14,2.2,17.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.75,13.1a5.2,5.2,0,0,0,1.44-1.29A5.2,5.2,0,0,1,10.75,13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.65,16.34c0,.69,0,1.38,0,2.06C.64,17.72.63,17,.65,16.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.51,6.21a4.85,4.85,0,0,0-1.25-1.42A4.85,4.85,0,0,1,12.51,6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.46,20.05a1.9,1.9,0,0,1-.67-.13A1.9,1.9,0,0,0,2.46,20.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.79,19.92a1.75,1.75,0,0,1-.57-.35A1.75,1.75,0,0,0,1.79,19.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.08,10.47a.94.94,0,0,1-.17.18,7,7,0,0,0-.76.78,7,7,0,0,1,.76-.78A.94.94,0,0,0,3.08,10.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.91,20.05h0c-3.82,0-7.63,0-11.45,0C6.28,20.07,10.09,20.07,13.91,20.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,19.72a1.83,1.83,0,0,0,.76-1.19A1.83,1.83,0,0,1,15,19.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.53,14.07a7.15,7.15,0,0,1,.22,1.28A7.15,7.15,0,0,0,15.53,14.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.66,18.4a1.59,1.59,0,0,0,.33.93,2.61,2.61,0,0,0,.23.24,1.75,1.75,0,0,0,.57.35,1.9,1.9,0,0,0,.67.13c3.82,0,7.63,0,11.45,0a1.58,1.58,0,0,0,.38,0,1.69,1.69,0,0,0,.67-.29,1.83,1.83,0,0,0,.76-1.19,2.6,2.6,0,0,0,0-.39c0-.93,0-1.86,0-2.79a7.15,7.15,0,0,0-.22-1.28c0-.14-.07-.28-.11-.42a1.19,1.19,0,0,0-.16-.34.72.72,0,0,0-.85-.26.71.71,0,0,0-.46.41,1.41,1.41,0,0,0-.06.63c.13,1.24.22,2.49.31,3.74a.88.88,0,0,1,0,.29.55.55,0,0,1-.12.21.71.71,0,0,1-.52.17c-3.56,0-7.13,0-10.69,0a.62.62,0,0,1-.51-.18.47.47,0,0,1-.11-.21,1.23,1.23,0,0,1,0-.29c0-.68,0-1.36,0-2A5.33,5.33,0,0,1,4,11.84l.13.05.42.4a5,5,0,0,0,1.53,1.08,5.09,5.09,0,0,0,3.8.15,4.83,4.83,0,0,0,.89-.42,5.2,5.2,0,0,0,1.44-1.29A4.93,4.93,0,0,0,13,10a5.68,5.68,0,0,0,.15-1,6.44,6.44,0,0,0,0-1,5.34,5.34,0,0,0-.63-1.81,4.85,4.85,0,0,0-1.25-1.42,4.33,4.33,0,0,0-.82-.51,5.09,5.09,0,0,0-2-.53,3.88,3.88,0,0,0-.59,0A5,5,0,0,0,3.3,7.37a5.09,5.09,0,0,0-.18,1.8,4.92,4.92,0,0,0,.09.64.76.76,0,0,1-.13.66.94.94,0,0,1-.17.18,7,7,0,0,0-.76.78A5.57,5.57,0,0,0,.81,14.3a19.79,19.79,0,0,0-.16,2C.63,17,.64,17.72.66,18.4ZM8.14,5.32a3.43,3.43,0,0,1,3.42,3.43A3.37,3.37,0,0,1,8.2,12.22,3.38,3.38,0,0,1,4.72,8.81,3.43,3.43,0,0,1,8.14,5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.55,59.28v0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,57.13a1,1,0,0,0-.39,0,1,1,0,0,1,.39,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.32,58.74a1.16,1.16,0,0,0,.37.13c.95.15,1.91.27,2.86.41-.95-.14-1.91-.26-2.86-.41A1.16,1.16,0,0,1,24.32,58.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.61,57.66a1.33,1.33,0,0,0-.32-.12,4.54,4.54,0,0,0-.51-.09c-.92-.11-1.84-.2-2.75-.32a1,1,0,0,0-.39,0,.92.92,0,0,0-.75.72.85.85,0,0,0,.43.88,1.16,1.16,0,0,0,.37.13c.95.15,1.91.27,2.86.41v0h.53a.83.83,0,0,0,.91-.78,1.17,1.17,0,0,0,0-.33A.76.76,0,0,0,28.61,57.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,59.28l1.46-.2-1.46.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.08,57.43c-.31,0-.61.08-.92.14a.86.86,0,0,0-.29.13.86.86,0,0,1,.29-.13C31.47,57.51,31.77,57.47,32.08,57.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.26,57.26a.82.82,0,0,1,.38.56,1.09,1.09,0,0,1,0,.36,1.09,1.09,0,0,0,0-.36A.82.82,0,0,0,35.26,57.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.54,57.12,33,57.33l-.92.1.92-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.26,57.26a1,1,0,0,0-.72-.14L33,57.33l-.92.1c-.31,0-.61.08-.92.14a.86.86,0,0,0-.29.13.65.65,0,0,0-.26.49.91.91,0,0,0,0,.33.72.72,0,0,0,.47.65,1.33,1.33,0,0,0,.3.06c.19,0,.39,0,.58,0v.05l1.46-.2,1.45-.22a1,1,0,0,0,.63-.36.9.9,0,0,0,.13-.32,1.09,1.09,0,0,0,0-.36A.82.82,0,0,0,35.26,57.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.2,45.25A5,5,0,0,1,55.48,47,5,5,0,0,0,56.2,45.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.15,41A4.87,4.87,0,0,1,56,42.45,4.87,4.87,0,0,0,55.15,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.78,47.61a5.32,5.32,0,0,0-.69.91A5.32,5.32,0,0,1,46.78,47.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.78,47.61a6,6,0,0,1,.44-.42h0A6,6,0,0,0,46.78,47.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.2,45.25a5.42,5.42,0,0,0,0-2A5.42,5.42,0,0,1,56.2,45.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45,55.37a1.8,1.8,0,0,0,.69.13c3.78,0,7.55,0,11.33,0h0c-3.78,0-7.55,0-11.33,0A1.8,1.8,0,0,1,45,55.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.32,53.34c0-.61-.07-1.23-.11-1.84,0,.61.08,1.23.11,1.84,0,.39-.19.61-.61.61h0C57.13,54,57.34,53.73,57.32,53.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.15,41a5.78,5.78,0,0,0-1.27-1.1A5.78,5.78,0,0,1,55.15,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.94,52.15c0,.39,0,.79-.06,1.18C58.91,52.94,58.93,52.54,58.94,52.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.88,48.46a.65.65,0,0,1,.29.11A.65.65,0,0,0,57.88,48.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.59,49.2a1.76,1.76,0,0,0-.18-.39.78.78,0,0,0-.24-.24.65.65,0,0,0-.29-.11,1.17,1.17,0,0,0-.36,0c-.44.13-.53.54-.46,1.16s.11,1.22.15,1.84.08,1.23.11,1.84c0,.39-.19.61-.61.61H46a.62.62,0,0,1-.48-.16.65.65,0,0,1-.16-.48c0-.36,0-.73,0-1.1s0-.74,0-1.1a5.49,5.49,0,0,1,.75-2.59,5.32,5.32,0,0,1,.69-.91,6,6,0,0,1,.44-.42h0l.19.26a1.63,1.63,0,0,0,.17.2c.16.17.33.33.5.48a5,5,0,0,0,1.68.93,5.11,5.11,0,0,0,1.24.21,5.55,5.55,0,0,0,1.33-.13,5,5,0,0,0,2.56-1.4,4.6,4.6,0,0,0,.59-.73,5,5,0,0,0,.72-1.76,5.42,5.42,0,0,0,0-2,4.42,4.42,0,0,0-.22-.79A4.87,4.87,0,0,0,55.15,41a5.78,5.78,0,0,0-1.27-1.1,4.9,4.9,0,0,0-2.35-.75,5.09,5.09,0,0,0-3.21,1,4.84,4.84,0,0,0-.83.74,5,5,0,0,0-1.25,3.74q0,.3.09.63a1.22,1.22,0,0,1,0,.26.67.67,0,0,1-.15.39l-.17.18a7,7,0,0,0-1.39,1.65,5.58,5.58,0,0,0-.72,2,25.6,25.6,0,0,0-.15,4.11A1.74,1.74,0,0,0,45,55.37a1.8,1.8,0,0,0,.69.13c3.78,0,7.55,0,11.33,0a2.15,2.15,0,0,0,.68-.11,1.71,1.71,0,0,0,1.19-1.47l0-.59c0-.39,0-.79.06-1.18a11.73,11.73,0,0,0-.09-1.78A8.19,8.19,0,0,0,58.59,49.2Zm-7.3-8.44a3.45,3.45,0,0,1,3.4,3.46,3.42,3.42,0,1,1-3.4-3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.42,56.57a.79.79,0,0,0-.25.83A.79.79,0,0,1,37.42,56.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42,55.71a.8.8,0,0,0-.75-.51A.8.8,0,0,1,42,55.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.29,55.84c-.53.19-1.07.37-1.6.58a1.17,1.17,0,0,0-.27.15,1.17,1.17,0,0,1,.27-.15C38.22,56.21,38.76,56,39.29,55.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.22,55.2a1.25,1.25,0,0,0-.32,0c-.54.18-1.07.39-1.61.59s-1.07.37-1.6.58a1.17,1.17,0,0,0-.27.15.79.79,0,0,0-.25.83,1.06,1.06,0,0,0,.93.81l1.82-.72c.61-.24,1.22-.49,1.81-.76a.44.44,0,0,0,.22-.18.83.83,0,0,0,0-.84A.8.8,0,0,0,41.22,55.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.27,28.83a.79.79,0,0,0-.34,0A.8.8,0,0,0,.68,29a.8.8,0,0,1,.25-.11A.79.79,0,0,1,1.27,28.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.54,29a.85.85,0,0,1,.28.6A.85.85,0,0,0,1.54,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.34,18.32a.62.62,0,0,0,.51.18A.62.62,0,0,1,2.34,18.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.91,20.05a1.58,1.58,0,0,0,.38,0,1.58,1.58,0,0,1-.38,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.88,13.81h0a5.18,5.18,0,0,1-1.82-.44A5.18,5.18,0,0,0,7.88,13.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1,19.33a1.59,1.59,0,0,1-.33-.93A1.59,1.59,0,0,0,1,19.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.3,7.37a5.09,5.09,0,0,0-.18,1.8A5.09,5.09,0,0,1,3.3,7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.89,14.09c.13,1.24.22,2.49.31,3.74a.88.88,0,0,1,0,.29.88.88,0,0,0,0-.29C14.11,16.58,14,15.33,13.89,14.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.77,18.14c0-.93,0-1.86,0-2.79C15.81,16.28,15.78,17.21,15.77,18.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.21,9.81a4.92,4.92,0,0,1-.09-.64,4.92,4.92,0,0,0,.09.64.76.76,0,0,1-.13.66A.76.76,0,0,0,3.21,9.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.53,14.07c0-.14-.07-.28-.11-.42a1.19,1.19,0,0,0-.16-.34,1.19,1.19,0,0,1,.16.34C15.46,13.79,15.49,13.93,15.53,14.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.21,54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.76,48.46a1,1,0,0,0-.34,0,.68.68,0,0,0-.27.13.68.68,0,0,1,.27-.13A1,1,0,0,1,14.76,48.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.42,49.11a23.35,23.35,0,0,1,.34,2.63A23.35,23.35,0,0,0,15.42,49.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.8,49.78a5.2,5.2,0,0,1,.26-1.05A5.2,5.2,0,0,0,.8,49.78a24.86,24.86,0,0,0-.15,4,1.6,1.6,0,0,0,.35.94,1.6,1.6,0,0,1-.35-.94A24.86,24.86,0,0,1,.8,49.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.89,49.52c.13,1.25.22,2.49.31,3.74a.76.76,0,0,1,0,.31.76.76,0,0,0,0-.31C14.11,52,14,50.77,13.89,49.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.24,51.09c0-.24,0-.47.06-.71a5.23,5.23,0,0,1,.2-.89,5.23,5.23,0,0,0-.2.89C2.27,50.62,2.26,50.85,2.24,51.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.18,44.24a6.06,6.06,0,0,0-.09-1,4.45,4.45,0,0,0-.23-.79,4.45,4.45,0,0,1,.23.79A6.06,6.06,0,0,1,13.18,44.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.61,54.34a2.28,2.28,0,0,0,.16-.74c0-.31,0-.62,0-.93,0,.31,0,.62,0,.93A2.28,2.28,0,0,1,15.61,54.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1,54.77a2,2,0,0,0,.51.45A2,2,0,0,1,1,54.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.42,40.42a5.11,5.11,0,0,1,1.44,2A5.11,5.11,0,0,0,11.42,40.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.5,55.5c3.8,0,7.59,0,11.39,0a1.82,1.82,0,0,0,1-.33,1.82,1.82,0,0,1-1,.33C10.09,55.52,6.3,55.51,2.5,55.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57,55.5a2.15,2.15,0,0,0,.68-.11,2.15,2.15,0,0,1-.68.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.52,48.5a1.17,1.17,0,0,1,.36,0A1.17,1.17,0,0,0,57.52,48.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.85,50.37a8.19,8.19,0,0,0-.26-1.17,1.76,1.76,0,0,0-.18-.39,1.76,1.76,0,0,1,.18.39A8.19,8.19,0,0,1,58.85,50.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.24,44.63q0,.3.09.63a1.22,1.22,0,0,1,0,.26,1.22,1.22,0,0,0,0-.26Q46.27,44.93,46.24,44.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.48,53.79a.65.65,0,0,1-.16-.48c0-.36,0-.73,0-1.1,0,.37,0,.74,0,1.1A.65.65,0,0,0,45.48,53.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.32,40.15a4.84,4.84,0,0,0-.83.74A4.84,4.84,0,0,1,48.32,40.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.21,45.91l-.17.18a6.78,6.78,0,0,0-1.39,1.65A7,7,0,0,1,46,46.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.22,47.19l.19.26-.19-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.41,47.45a1.63,1.63,0,0,0,.17.2c.16.17.33.33.5.48-.17-.15-.34-.31-.5-.48A1.63,1.63,0,0,1,47.41,47.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51,49.27a5.55,5.55,0,0,0,1.33-.13,5,5,0,0,0,2.56-1.4,5,5,0,0,1-2.56,1.4A5.55,5.55,0,0,1,51,49.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51,49.27a5.11,5.11,0,0,1-1.24-.21A5.11,5.11,0,0,0,51,49.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,2.1c-1.13.31-2.28.58-3.43.83,1.15-.25,2.3-.52,3.43-.83a.81.81,0,0,0,.5-.39A.81.81,0,0,1,25,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.27,2.94a.75.75,0,0,1-.49-.3A.75.75,0,0,0,21.27,2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.82.29l-1,.25,1-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.92,57.49c.61-.24,1.22-.49,1.81-.76a.44.44,0,0,0,.22-.18.44.44,0,0,1-.22.18C41.14,57,40.53,57.25,39.92,57.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.22,55.2a1.19,1.19,0,0,0-.32,0c-.54.18-1.07.39-1.61.59.54-.2,1.07-.41,1.61-.59A1.25,1.25,0,0,1,41.22,55.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.28,55.21a.79.79,0,0,0-.73.59.91.91,0,0,0-.07.35.91.91,0,0,1,.07-.35A.79.79,0,0,1,18.28,55.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.33,56.83a.83.83,0,0,0-.45-.39A.83.83,0,0,1,22.33,56.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.29,58.08h0L21.07,58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.61,58.19a.65.65,0,0,1,.26-.49A.65.65,0,0,0,30.61,58.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,59.28h0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.08,59.17a1.33,1.33,0,0,0,.3.06c.19,0,.39,0,.58,0-.19,0-.39,0-.58,0A1.33,1.33,0,0,1,31.08,59.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.51,58.5a1,1,0,0,1-.63.36A1,1,0,0,0,35.51,58.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.63,40.4a.9.9,0,0,1-.32-.09A.9.9,0,0,0,2.63,40.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.53,39.16c-.3-1-.6-2-.92-3a1.14,1.14,0,0,0-.22-.41,1.14,1.14,0,0,1,.22.41C2.93,37.13,3.23,38.14,3.53,39.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.55,59.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29,58.13a.76.76,0,0,0-.36-.47A.76.76,0,0,1,29,58.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.29,57.54a1.33,1.33,0,0,1,.32.12,1.33,1.33,0,0,0-.32-.12,4.54,4.54,0,0,0-.51-.09c-.92-.11-1.84-.2-2.75-.32h0c.91.12,1.83.21,2.75.32A4.54,4.54,0,0,1,28.29,57.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18,2.38l.21-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.4,5.59a1,1,0,0,0,.33-.09l1.46-.72-1.46.72A1,1,0,0,1,15.4,5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.45,4.85a1,1,0,0,0,.13.32.88.88,0,0,0,.22.25.88.88,0,0,1-.22-.25A1,1,0,0,1,14.45,4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.6,23.25c-.18,1-.37,2.05-.55,3.07.18-1,.37-2,.55-3.07a1,1,0,0,0-.11-.67A1,1,0,0,1,2.6,23.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.23,26.15c.21-1.12.41-2.24.65-3.34C.64,23.91.44,25,.23,26.15a1,1,0,0,0,.88,1.08h0A1,1,0,0,1,.23,26.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.88,26.46a7.88,7.88,0,0,0-7.28-6.34c-3.29-.09-6.58,0-9.88,0a6.47,6.47,0,0,0-1.32.1,7.9,7.9,0,0,0-6.48,6.12.66.66,0,0,1-.7.58,7.6,7.6,0,0,0-2.08.41A6.26,6.26,0,0,0,14,32.55a6.48,6.48,0,0,0,3,6.68,1.94,1.94,0,0,1,.65.54,8.52,8.52,0,0,0,4.38,3.73.92.92,0,0,0,1.13-.09c.33-.33.22-.69.08-1.08s-.3-1-.44-1.49.06-.68.59-.67c1.47,0,2.94,0,4.41,0a6.12,6.12,0,0,0,5.51-3.37,1.19,1.19,0,0,1,1.27-.71c.54,0,.7.2.55.71-.24.79-.5,1.58-.67,2.38a1.21,1.21,0,0,0,.15.95,1.07,1.07,0,0,0,.93.12,12.11,12.11,0,0,0,2-1,8.94,8.94,0,0,0,3.69-3.67,1.45,1.45,0,0,1,.56-.47,8,8,0,0,0,4.21-7.21C46,27.53,46,27,45.88,26.46ZM40.8,33.88a1.72,1.72,0,0,0-.94.95A7.08,7.08,0,0,1,36.7,38c0-.33,0-.55,0-.76,0-.64.07-1.28.06-1.91s-.38-.77-1-.77c-2.19,0-4.38,0-6.56,0a15.54,15.54,0,0,1-2.79-.42c-.6-.12-1,0-1.18.42A.79.79,0,0,0,26,35.6a18.49,18.49,0,0,0,2.84.47c1,.08,2,0,3.14,0-.19.31-.28.48-.39.62a4.69,4.69,0,0,1-3.75,1.89c-1.84,0-3.68,0-5.52,0-.77,0-1.05.28-1.07,1V41.2a4.76,4.76,0,0,1-2-2.12,2,2,0,0,0-1-1,5.09,5.09,0,0,1-2.6-5.38,5,5,0,0,1,4.48-4.22c.44-.05.65,0,.69.57a9.51,9.51,0,0,0,.43,1.79c.2.64.57.88,1,.73s.67-.58.44-1.25a6.32,6.32,0,0,1,.07-4.53,6.51,6.51,0,0,1,5.91-4.07q4.68,0,9.36,0a6.58,6.58,0,0,1,6.28,5A6.4,6.4,0,0,1,40.8,33.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44,14.18a32.13,32.13,0,0,0-.21,3.93,1.84,1.84,0,0,0,1.88,1.94c3.8,0,7.59,0,11.39,0a1.89,1.89,0,0,0,1.87-2,17,17,0,0,0,0-1.75,26.91,26.91,0,0,0-.35-2.68.75.75,0,0,0-1-.61c-.5.17-.56.56-.52,1,.12,1.22.22,2.45.31,3.68,0,.49-.18.74-.72.73-3.52,0-7,0-10.57,0-.55,0-.73-.24-.72-.73s0-1.28,0-1.92a5.49,5.49,0,0,1,1.9-4.12,4.78,4.78,0,0,0,.35.47A5,5,0,0,0,56.24,8,5,5,0,1,0,46.33,9.8a.76.76,0,0,1-.28.84A6,6,0,0,0,44,14.18ZM51.3,5.32a3.43,3.43,0,0,1,3.39,3.47,3.42,3.42,0,1,1-6.84,0A3.43,3.43,0,0,1,51.3,5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.37,28.75a1.11,1.11,0,0,0-.64.69c-.14,1.15-.2,2.31-.25,3.47a.89.89,0,1,0,1.77.07c.08-1,.15-2,.24-3.14a2.8,2.8,0,0,0-.16-.66A.73.73,0,0,0,58.37,28.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.55,2.13l3.21.76a.86.86,0,0,0,1-.6.77.77,0,0,0-.47-1C37.15.88,36,.61,34.86.33c-.58.11-.94.3-1,.81A.83.83,0,0,0,34.55,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.15,1.78c.52,0,1,0,1.56,0s1.05,0,1.57,0a.9.9,0,0,0,1-.9.87.87,0,0,0-1-.87h-3.2a.92.92,0,0,0-1,.86A1,1,0,0,0,28.15,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.15,1.78c.52,0,1,0,1.56,0s1.05,0,1.57,0c-.52,0-1.05,0-1.57,0S28.67,1.79,28.15,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.55,22.1a.92.92,0,0,0-.64,1.14c.19,1,.38,2.05.56,3.07a.93.93,0,0,0,1,.81.91.91,0,0,0,.8-.95c0-.35-.06-.68-.12-1-.14-.78-.29-1.56-.46-2.33A.87.87,0,0,0,57.55,22.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.46,37.74c-.15.5-.35,1-.47,1.49a.84.84,0,0,0,.53,1.08.75.75,0,0,0,1-.37c.44-1.19.8-2.4,1.2-3.61a1.07,1.07,0,0,0-.89-.94.89.89,0,0,0-.95.69C56.75,36.63,56.62,37.19,56.46,37.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.74,4c1,.49,1.93,1,2.9,1.45a.89.89,0,0,0,1.23-.29.91.91,0,0,0-.42-1.27c-.92-.49-1.86-1-2.8-1.41a2.77,2.77,0,0,0-.49-.15L41,2.2c-.25.22-.6.4-.73.69A.8.8,0,0,0,40.74,4Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage6);
export default __webpack_public_path__ + "static/media/Image6.753dc63c6e6e5a7237ca7d3194297a96.svg";
export { ForwardRef as ReactComponent };